import type { TrackerSchedule } from '@/types/trackers';
import { todayISO } from '@/utils/date';

export function computeNextDue(schedule: TrackerSchedule, fromISO?: string): string | null {
  try {
    const start = fromISO || todayISO();
    const base = new Date(start);
    if (isNaN(+base)) return null;

    const cadence = schedule?.cadence ?? 'weekly';
    const dowRaw = Array.isArray(schedule?.daysOfWeek) && schedule.daysOfWeek.length ? schedule.daysOfWeek : [0];

    const next = new Date(base);
    next.setDate(next.getDate() + 1); // avoid firing for today immediately after log

    function isMatch(d: Date) {
      const dow = d.getDay();
      if (cadence === 'weekly' || cadence === 'biweekly') {
        return dowRaw.includes(dow);
      }
      if (cadence === 'monthly' && Array.isArray(schedule.daysOfMonth) && schedule.daysOfMonth.length) {
        return schedule.daysOfMonth.includes(d.getDate());
      }
      if (cadence === 'custom' && Array.isArray(dowRaw)) {
        return dowRaw.includes(dow);
      }
      return dowRaw.includes(dow);
    }

    for (let i = 0; i < 60; i++) {
      if (isMatch(next)) {
        if (cadence === 'biweekly') {
          const ref = new Date(start);
          const diffDays = Math.floor((+next - +ref) / 86400000);
          const weeks = Math.floor(diffDays / 7);
          if (weeks % 2 === 1) {
            next.setDate(next.getDate() + 1);
            continue;
          }
        }
        const y = next.getFullYear();
        const m = String(next.getMonth() + 1).padStart(2, '0');
        const d = String(next.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      }
      next.setDate(next.getDate() + 1);
    }
    return null;
  } catch {
    return null;
  }
}
